import { mediaUrl } from "@/lib/mediaUrl";
import { alSareeCaseStudy } from "@/data/alSareeCaseStudy";

const alSareeGallery = [
  "/project-assets/al-saree/orders-redacted.png",
  "/project-assets/al-saree/merchant-redacted.png",
  "/project-assets/al-saree/insights-private.png",
  "/project-assets/al-saree/drivers-private.png",
];

export const content = {
  ar: {
    dir: "rtl",
    brand: {
      name: "YacoubCreates",
      domain: "yacoub-creates.io",
      tagline: "حلول رقمية توضّح عرضك وتسهّل عملك.",
    },
    nav: {
      build: "الحلول",
      work: "مشاريع نفّذتها",
      explainers: "فيديوهات المنتجات",
      resources: "أدوات وموارد",
      cta: "راسلني",
      menu: "القائمة",
      close: "إغلاق",
    },
    langSwitch: { label: "التبديل إلى الإنجليزية", short: "EN" },
    hero: {
      eyebrow: "لأصحاب الأعمال والمتاجر والمنتجات الرقمية",
      title: "وضّح عرضك لعملائك.",
      sub: "أنا يعقوب. أبني مواقع توضّح ما تبيع، وأنظمة تنظّم عملك، وأصنع فيديوهات إعلانية ومحتوى يشرح منتجك.",
      primary: "ناقش مشروعك على واتساب",
      secondary: "شاهد ما نفّذت",
      imageAlt: "صورة فنية ليعقوب تحيط بها بطاقات عن أدوات البناء والتخطيط",
      clientsTitle: "عملاء سابقون",
      clientsNote: "تجارب عمل بدأت بفكرة وأصبحت واقعًا.",
      noteTitle: "من المشكلة إلى التنفيذ",
      noteSub: "نفهم الحاجة، ثم نبني الحل المناسب.",
      scrollCue: "اكتشف مجالات العمل",
      titleAccent: "وسهّل العمل على فريقك.",
      reassurance: "أرسل ما تريد تحسينه. أردّ عليك بنفسي، ونحدّد الخطوة المناسبة دون التزام.",
      proofLabel: "من مشاريعي:",
      proofSadeed: "سديد — إدارة التجارة",
      proofSaree: "السريع — إدارة التوصيل",
    },
    build: {
      eyebrow: "ما الذي تريد تحسينه؟",
      title: "حلول",
      sub: "اختر الأقرب إلى احتياجك. نبدأ بمشكلة واضحة، ونحدّد ما تحتاجه لحلّها.",
      services: [
        {
          "title": "المواقع وصفحات الهبوط",
          "desc": "خدمتك جيدة لكن شرحها صعب؟ أصمّم موقعًا أو صفحة هبوط تعرض ما تقدّمه، وتجيب عن أسئلة العميل، وتسهّل عليه التواصل من الهاتف.",
          "chips": [
            "مواقع أعمال",
            "صفحات هبوط",
            "عربي ومتعدد اللغات"
          ],
          "theme": "charcoal"
        },
        {
          "title": "الأنظمة وإدارة العمل",
          "desc": "طلباتك ومخزونك موزّعة بين الرسائل والجداول؟ أبني نظامًا يجمعها في مكان واحد، مع ربط أدواتك وأتمتة التنبيهات والمهام المتكررة، وإضافة الذكاء الاصطناعي عند الحاجة.",
          "chips": [
            "طلبات ومخزون",
            "لوحات إدارة",
            "ربط وأتمتة"
          ],
          "theme": "sage"
        },
        {
          "title": "الإعلانات ومحتوى المنتجات",
          "desc": "منتجك يحتاج إلى شرح أو عرض يجذب الانتباه؟ أصنع فيديوهات ترويجية وشروحات قصيرة تُظهر فائدته وطريقة استخدامه، من الفكرة والنص إلى المونتاج والحركة.",
          "chips": [
            "فيديوهات ترويجية",
            "شروحات المنتجات",
            "موشن جرافيك"
          ],
          "theme": "graphite"
        }
      ],
      cta: "ناقش هذا الحل",
    },
    work: {
      eyebrow: "شاهد الحل وهو يعمل",
      title: "من احتياج يومي إلى نظام عملي",
      sub: "استكشف سديد والسريع: كيف تنتظم المنتجات والطلبات والتوصيل داخل تجربة واحدة.",
      askCta: "ناقش احتياجًا مشابهًا",
      viewProject: "شاهد المشروع",
      viewScreenshots: "شاهد لقطات النظام",
      viewDetails: "استكشف تفاصيل النظام",
      closeDetails: "إغلاق تفاصيل المشروع",
      galleryDetails: "كيف يعمل النظام",
      closeScreenshots: "إغلاق اللقطات",
      soonLabel: "قريباً",
      upcomingTitle: "مشاريع قادمة",
      projects: [
        {
          title: "سديد",
          latin: "Sadeed",
          slug: "sadeed",
    cover_url: mediaUrl("/project-assets/sadeed/cover.png"),
          type: "تطبيق لإدارة التجارة الإلكترونية",
          statement:
            "من صورة المنتج إلى المتجر والطلب والتوصيل: تطبيق واحد يساعد التاجر الإلكتروني في موريتانيا على إدارة يومه بوضوح.",
          theme: "charcoal",
          icon: "store",
          status: "live",
        },
        {
          title: "السريع للتوصيل",
          latin: "السريع",
          type: "نظام تشغيل وإدارة التوصيل",
          statement:
            "صمّمت وطوّرت نظام السريع كاملاً، من الواجهة والخادم إلى الأتمتة، ليربط خدمة العملاء والتجار والسائقين والمحاسبة لحظياً من أول طلب حتى التسليم.",
          statsDate: "أرقام النظام في 1 أكتوبر 2026",
          stats: [
            { count: 9198, label: "عميل مسجّل" },
            { count: 317, label: "عميل VIP" },
            { count: 1500, approximate: true, label: "سائق حر" },
          ],
          cover_url: mediaUrl("/project-assets/al-saree/cover.png"),
          caseStudy: alSareeCaseStudy.ar,
          theme: "sage",
          icon: "delivery",
          galleryOnly: true,
          gallery: alSareeGallery,
          status: "live",
        },
      ],
      upcoming: [
        {
          title: "مشروع أتمتة",
          type: "أتمتة وسير عمل",
          statement: "قيد العمل — تُنشر تفاصيله هنا عند اكتماله.",
        },
        {
          title: "شرح منتج SaaS",
          type: "فيديو توضيحي",
          statement: "قيد العمل — تُنشر تفاصيله هنا عند اكتماله.",
        },
      ],
    },
    explainers: {
      eyebrow: "اجعل فائدة منتجك واضحة",
      category: "فيديوهات شرح المنتجات",
      intro: "شاهد كيف يتحوّل استخدام المنتج إلى قصة قصيرة يفهمها عميلك، من أول خطوة إلى النتيجة.",
      previous: "الفيديو السابق",
      next: "الفيديو التالي",
      play: "شغّل",
      watch: "شاهد الفيديو",
      awaiting: "الفيديو قيد الإضافة",
      close: "أغلق الفيديو",
    },
    resources: {
      eyebrow: "ابدأ بفكرة قابلة للتطبيق",
      title: "أدوات وموارد",
      sub: "أدوات وقوالب وأدلة تساعدك على تجربة الأفكار وتبسيط العمل.",
      openCta: "فتح المورد",
    },
    contact: {
      title: "ما الذي يعطّل عملك اليوم؟",
      sub: "أرسل وصفًا قصيرًا للمشكلة أو رابط منتجك، وما تريد تحسينه. لا تحتاج إلى معرفة تقنية أو ملف متطلبات لتبدأ.",
      cta: "تواصل معي عبر البريد",
      email: "hello@yacoubcreates.io",
      note: "يمكنك مراسلتي مباشرة على هذا البريد.",
    },
    footer: {
      tagline: "حلول رقمية توضّح عرضك وتسهّل عملك.",
      rights: "© 2026 YacoubCreates — جميع الحقوق محفوظة.",
    },
  },
  en: {
    dir: "ltr",
    brand: {
      name: "YacoubCreates",
      domain: "yacoub-creates.io",
      tagline: "Make your offer clear. Make work simpler.",
    },
    nav: {
      build: "Solutions",
      work: "Projects",
      explainers: "Product videos",
      resources: "Tools & resources",
      cta: "Get in touch",
      menu: "Menu",
      close: "Close",
    },
    langSwitch: { label: "Switch to Arabic", short: "ع" },
    hero: {
      eyebrow: "For business owners, merchants and digital product teams",
      title: "Make your offer clear.",
      sub: "I'm Yacoub. I build websites that explain your offer, systems that organize your work, and promotional videos and content that showcase your product.",
      primary: "Discuss your project on WhatsApp",
      secondary: "See my projects",
      imageAlt: "An artistic portrait of Yacoub surrounded by cards showing tools for building and planning",
      clientsTitle: "Past clients",
      clientsNote: "Work that started with an idea and became real.",
      noteTitle: "From problem to delivery",
      noteSub: "Understand the need. Build the right solution.",
      scrollCue: "Explore my work",
      titleAccent: "Make daily work simpler.",
      reassurance: "Tell me what you want to improve. I'll reply personally and help you find the next step, with no commitment.",
      proofLabel: "Projects I've built:",
      proofSadeed: "Sadeed — commerce",
      proofSaree: "Al Saree — delivery",
    },
    build: {
      eyebrow: "What would you like to improve?",
      title: "Solutions",
      sub: "Start with the problem you recognize. We'll work out what you need to solve it.",
      services: [
        {
          "title": "Websites & landing pages",
          "desc": "Great service, hard to explain? I design websites and landing pages that clarify your offer, answer customer questions and make it easy to contact you on mobile.",
          "chips": [
            "Business websites",
            "Landing pages",
            "Multilingual sites"
          ],
          "theme": "charcoal"
        },
        {
          "title": "Systems & operations",
          "desc": "Orders and inventory scattered across chats and spreadsheets? I build a system that brings them together, connects your tools and automates updates and repetitive tasks, with AI where it helps.",
          "chips": [
            "Orders & inventory",
            "Management dashboards",
            "Integrations & automation"
          ],
          "theme": "sage"
        },
        {
          "title": "Ads & product content",
          "desc": "Does your product need a clearer explanation or a compelling introduction? I create promotional videos and short explainers that show its value and how to use it, from the concept and script to editing and motion.",
          "chips": [
            "Promotional videos",
            "Product explainers",
            "Motion graphics"
          ],
          "theme": "graphite"
        }
      ],
      cta: "Discuss this solution",
    },
    work: {
      eyebrow: "See the solution at work",
      title: "Everyday problems. Working systems.",
      sub: "Explore Sadeed and Al Saree to see how products, orders and delivery come together in one workflow.",
      askCta: "Discuss a similar need",
      viewProject: "View project",
      viewScreenshots: "View system screenshots",
      viewDetails: "Explore the system",
      closeDetails: "Close project details",
      galleryDetails: "How the system works",
      closeScreenshots: "Close screenshots",
      soonLabel: "Coming soon",
      upcomingTitle: "Upcoming projects",
      projects: [
        {
          title: "Sadeed",
          latin: "سديد",
          slug: "sadeed",
    cover_url: mediaUrl("/project-assets/sadeed/cover.png"),
          type: "E-commerce management app",
          statement:
            "From product photo to storefront, order, and delivery: one app for a Mauritanian online merchant's daily work.",
          theme: "charcoal",
          icon: "store",
          status: "live",
        },
        {
          title: "Al Saree Delivery",
          latin: "Al Saree",
          type: "Private delivery operations platform",
          statement:
            "I designed and built Al Saree end to end, from its interface and backend to its automations, connecting support, merchants, drivers, and accounting from the first order through delivery.",
          statsDate: "System figures as of October 1, 2026",
          stats: [
            { count: 9198, label: "registered customers" },
            { count: 317, label: "VIP customers" },
            { count: 1500, approximate: true, label: "freelance drivers" },
          ],
          cover_url: mediaUrl("/project-assets/al-saree/cover.png"),
          caseStudy: alSareeCaseStudy.en,
          theme: "sage",
          icon: "delivery",
          galleryOnly: true,
          gallery: alSareeGallery,
          status: "live",
        },
      ],
      upcoming: [
        {
          title: "Automation project",
          type: "Automation & workflows",
          statement: "In progress — details will be published once complete.",
        },
        {
          title: "SaaS explainer",
          type: "Explainer video",
          statement: "In progress — details will be published once complete.",
        },
      ],
    },
    explainers: {
      eyebrow: "Make your product's value clear",
      category: "Product explainer videos",
      intro: "See how a product journey becomes a short story your customer can follow, from the first step to the outcome.",
      previous: "Previous video",
      next: "Next video",
      play: "Play",
      watch: "Watch video",
      awaiting: "Video coming soon",
      close: "Close video",
    },
    resources: {
      eyebrow: "Start with something practical",
      title: "Tools & resources",
      sub: "Tools, templates and guides to help you try ideas and simplify your work.",
      openCta: "Open resource",
    },
    contact: {
      title: "What's slowing your work down?",
      sub: "Send a short description of the problem or a link to your product, and what you want to improve. You don't need technical knowledge or a full brief to start.",
      cta: "Get in touch by email",
      email: "hello@yacoubcreates.io",
      note: "You can email me directly at this address.",
    },
    footer: {
      tagline: "Make your offer clear. Make work simpler.",
      rights: "© 2026 YacoubCreates — All rights reserved.",
    },
  },
  fr: {
    dir: "ltr",
    brand: {
      name: "YacoubCreates",
      domain: "yacoub-creates.io",
      tagline: "Une offre claire. Un travail plus simple.",
    },
    nav: {
      build: "Solutions",
      work: "Projets",
      explainers: "Vidéos produit",
      resources: "Outils & ressources",
      cta: "Me contacter",
      menu: "Menu",
      close: "Fermer",
    },
    langSwitch: { label: "Changer de langue", short: "ع" },
    hero: {
      eyebrow: "Pour les entrepreneurs, commerçants et équipes produit",
      title: "Clarifiez votre offre.",
      sub: "Je suis Yacoub. Je crée des sites qui présentent votre offre, des systèmes qui organisent votre travail, et des vidéos promotionnelles et du contenu pour votre produit.",
      primary: "Parlons de votre projet sur WhatsApp",
      secondary: "Voir mes projets",
      imageAlt: "Portrait artistique de Yacoub entouré de cartes présentant ses outils de création et de planification",
      clientsTitle: "Anciens clients",
      clientsNote: "Des projets nés d'une idée et devenus concrets.",
      noteTitle: "Du besoin à la réalisation",
      noteSub: "Comprendre le problème, construire la solution.",
      scrollCue: "Explorer mes domaines",
      titleAccent: "Simplifiez votre quotidien.",
      reassurance: "Dites-moi ce que vous souhaitez améliorer. Je réponds personnellement pour définir la prochaine étape, sans engagement.",
      proofLabel: "Mes réalisations :",
      proofSadeed: "Sadeed — commerce",
      proofSaree: "Al Saree — livraison",
    },
    build: {
      eyebrow: "Que souhaitez-vous améliorer ?",
      title: "Solutions",
      sub: "Partez du problème qui vous concerne. Nous définirons ensemble la solution adaptée.",
      services: [
        {
          "title": "Sites & pages de vente",
          "desc": "Votre service est difficile à expliquer ? Je crée un site ou une page de vente qui présente votre offre, répond aux questions des clients et facilite le contact sur mobile.",
          "chips": [
            "Sites professionnels",
            "Pages de vente",
            "Sites multilingues"
          ],
          "theme": "charcoal"
        },
        {
          "title": "Systèmes de gestion",
          "desc": "Commandes et stocks dispersés entre messages et tableaux ? Je crée un système qui les réunit, connecte vos outils et automatise les alertes et les tâches répétées, avec de l’IA lorsque c’est utile.",
          "chips": [
            "Commandes & stocks",
            "Tableaux de bord",
            "Connexions & automatisation"
          ],
          "theme": "sage"
        },
        {
          "title": "Publicités & contenu produit",
          "desc": "Votre produit mérite une présentation claire et attrayante ? Je crée des vidéos promotionnelles et des explications courtes qui montrent son intérêt et son utilisation, du concept et du script au montage et à l’animation.",
          "chips": [
            "Vidéos promotionnelles",
            "Vidéos explicatives",
            "Motion design"
          ],
          "theme": "graphite"
        }
      ],
      cta: "Discuter de cette solution",
    },
    work: {
      eyebrow: "La solution en action",
      title: "Des besoins concrets. Des systèmes utiles.",
      sub: "Découvrez comment Sadeed et Al Saree réunissent produits, commandes et livraison dans un même parcours.",
      askCta: "Discuter d'un besoin similaire",
      viewProject: "Voir le projet",
      viewScreenshots: "Voir les captures du système",
      viewDetails: "Découvrir le système",
      closeDetails: "Fermer les détails du projet",
      galleryDetails: "Fonctionnement du système",
      closeScreenshots: "Fermer les captures",
      soonLabel: "Bientôt",
      upcomingTitle: "Projets à venir",
      projects: [
        {
          title: "Sadeed",
          latin: "سديد",
          slug: "sadeed",
    cover_url: mediaUrl("/project-assets/sadeed/cover.png"),
          type: "Application de gestion du commerce en ligne",
          statement:
            "De la photo au magasin, puis à la commande et à la livraison : une application pour le quotidien du commerçant en ligne mauritanien.",
          theme: "charcoal",
          icon: "store",
          status: "live",
        },
        {
          title: "Al Saree Livraison",
          latin: "Al Saree",
          type: "Plateforme interne de gestion des livraisons",
          statement:
            "J'ai conçu et développé Al Saree de bout en bout, de l'interface au serveur et aux automatisations, pour relier le service client, les commerçants, les livreurs et la comptabilité jusqu'à la livraison.",
          statsDate: "Chiffres du système au 1er octobre 2026",
          stats: [
            { count: 9198, label: "clients inscrits" },
            { count: 317, label: "clients VIP" },
            { count: 1500, approximate: true, label: "livreurs indépendants" },
          ],
          cover_url: mediaUrl("/project-assets/al-saree/cover.png"),
          caseStudy: alSareeCaseStudy.fr,
          theme: "sage",
          icon: "delivery",
          galleryOnly: true,
          gallery: alSareeGallery,
          status: "live",
        },
      ],
      upcoming: [
        {
          title: "Projet d'automatisation",
          type: "Automatisation & workflows",
          statement: "En cours — les détails seront publiés une fois terminé.",
        },
        {
          title: "Explainer SaaS",
          type: "Vidéo explicative",
          statement: "En cours — les détails seront publiés une fois terminé.",
        },
      ],
    },
    explainers: {
      eyebrow: "Montrez la valeur de votre produit",
      category: "Vidéos de présentation produit",
      intro: "Un parcours produit devient une courte histoire que votre client peut suivre, de la première étape au résultat.",
      previous: "Vidéo précédente",
      next: "Vidéo suivante",
      play: "Lire",
      watch: "Voir la vidéo",
      awaiting: "Vidéo à venir",
      close: "Fermer la vidéo",
    },
    resources: {
      eyebrow: "Passez à la pratique",
      title: "Outils & ressources",
      sub: "Des outils, modèles et guides pour essayer des idées et simplifier votre travail.",
      openCta: "Ouvrir la ressource",
    },
    contact: {
      title: "Qu'est-ce qui ralentit votre travail ?",
      sub: "Envoyez une courte description ou un lien vers votre produit, et ce que vous souhaitez améliorer. Pas besoin de connaissances techniques ou d'un cahier des charges pour commencer.",
      cta: "Me contacter par email",
      email: "hello@yacoubcreates.io",
      note: "Vous pouvez m'écrire directement à cette adresse.",
    },
    footer: {
      tagline: "Une offre claire. Un travail plus simple.",
      rights: "© 2026 YacoubCreates — Tous droits réservés.",
    },
  },
};
